import { type PageTourStep } from '@apps/web/components/page_tour/page_tour';

export const HOME_PAGE_TOUR_STEPS: ReadonlyArray<PageTourStep> = [
    {
        targetTestIds: ['home-shifts-section'],
        title: 'Shifts on Home',
        body: 'Open shifts that still need a caregiver. Start outreach or open a shift from here.',
    },
    {
        targetTestIds: ['home-outreaches-section'],
        title: 'Outreaches on Home',
        body: 'A quick list of recent outreaches. Switch between all outreaches and yours.',
    },
];

export const SHIFTS_PAGE_TOUR_STEPS: ReadonlyArray<PageTourStep> = [
    {
        targetTestIds: ['shifts-date-controls'],
        title: 'Pick your dates',
        body: 'Use Today, the arrows, or the date picker to choose which days you’re viewing.',
    },
    {
        targetTestIds: ['shifts-stats'],
        title: 'Confirmations at a glance',
        body: 'Phoebe reaches out to confirm upcoming shifts. These counts show who has confirmed and who is still waiting to respond.',
    },
    {
        targetTestIds: ['shifts-table'],
        title: 'Work a shift',
        body: 'Click a shift to open it — from there you can start an outreach to fill it. Use the checkboxes to select several shifts and send one outreach for all of them.',
    },
];

export const OUTREACHES_PAGE_TOUR_STEPS: ReadonlyArray<PageTourStep> = [
    {
        targetTestIds: ['outreach-tabs'],
        title: 'Outreach types',
        body: 'Switch between open-shift outreaches, timekeeping reminders, surveys, and messages.',
    },
    {
        targetTestIds: ['outreach-new-button'],
        title: 'Start an outreach',
        body: 'Click New Outreach to have Phoebe call and text caregivers to fill an open shift.',
    },
    {
        targetTestIds: ['outreach-active-list'],
        title: 'Track responses',
        body: 'Active outreaches update in real time. Click one to see who Phoebe contacted and how each caregiver responded.',
    },
];

export const OUTREACH_DETAIL_PAGE_TOUR_STEPS: ReadonlyArray<PageTourStep> = [
    {
        targetTestIds: ['outreach-details-panel'],
        title: 'Outreach controls',
        body: 'Check where this outreach stands, pause or resume it, add more people, or open the exact instructions Phoebe is following.',
    },
    {
        targetTestIds: ['outreach-shifts-table', 'mobile-shift-summary-card'],
        title: 'The shifts to fill',
        body: 'Phoebe is working to fill these shifts. Once a caregiver is assigned, it shows here.',
    },
    {
        targetTestIds: ['outreach-caregivers-section'],
        title: 'Caregivers and responses',
        body: 'Phoebe contacts these caregivers and logs every response here. When someone can cover the shift, click Assign & Fill to lock it in.',
    },
    {
        targetTestIds: ['outreach-activity-tab'],
        title: 'Every step Phoebe took',
        body: 'Open the Activity tab to see the timeline of every call, text, and update for this outreach.',
    },
];

export const VOICE_CALLS_PAGE_TOUR_STEPS: ReadonlyArray<PageTourStep> = [
    {
        targetTestIds: ['voice-calls-filters'],
        title: 'Find a call',
        body: 'Search by name, number, or keyword, or pick a date range and direction to pull up a specific call.',
    },
    {
        targetTestIds: ['voice-call-list', 'voice-call-table'],
        title: 'The call feed',
        body: 'Every call Phoebe handles shows up here as it happens. Click a call to open it.',
    },
    {
        targetTestIds: ['voice-calls-detail-pane'],
        title: 'Call details',
        body: 'Read the transcript, play the recording, and review the notes Phoebe took. When a call is about an outreach, click the link to jump to that shift.',
    },
];

export const CAREGIVERS_PAGE_TOUR_STEPS: ReadonlyArray<PageTourStep> = [
    {
        targetTestIds: ['caregiver-search-input'],
        title: 'Search caregivers',
        body: 'Type a name to jump straight to a caregiver.',
    },
    {
        targetTestIds: ['caregiver-list-table'],
        title: 'Your caregivers',
        body: 'Click a caregiver to open their profile — recent calls and texts, what Phoebe has learned about them, and their availability.',
    },
    {
        targetTestIds: ['caregiver-add-button'],
        title: 'Add caregivers',
        body: 'Click here to add caregivers so you can practice outreach during training.',
    },
];

export const TEACH_PHOEBE_PAGE_TOUR_STEPS: ReadonlyArray<PageTourStep> = [
    {
        targetTestIds: ['teach-phoebe-progress-card'],
        title: 'Your training window',
        body: 'Phoebe learns how your agency works over a 21-day training period. This band tracks your day count as training progresses.',
    },
    {
        targetTestIds: ['teach-phoebe-needs-review'],
        title: 'Review Phoebe’s work',
        body: 'When Phoebe sends outreach or handles a call, it shows up here. Thumbs up confirms good work; thumbs down with a note teaches Phoebe what to do differently.',
    },
    {
        targetTestIds: ['teach-phoebe-coverage'],
        title: 'What Phoebe has learned',
        body: 'Scroll down to see notes and facts Phoebe has picked up about your caregivers and clients as training continues.',
    },
];
